export default "__VITE_ASSET__C48XGqky__"